import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { ReporteVentasPPForm } from "./form";
type Entity = models.ReporteVentaPPParametros;

interface Props {
    IdSucursalUsuario: number | undefined;
    permisos: models.Rol;
}
interface State {
    value: Promise<Entity> | Entity;
}
class ReporteVentasPPNoRX extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            value: {
                IdSucursal: this.props.permisos.Reportes.VerTodasSucursalesReporteVentaPP ? undefined : this.props.IdSucursalUsuario
            }
        };
    }

    puedeCambiarSucursal = (props: Props) => props.permisos.Reportes.VerTodasSucursalesReporteVentaPP;

    onChange = (value: Entity) => new Promise<void>(resolve => this.setState({ value: value }, resolve));

    onGenerar = async () => {
        const value = await this.state.value;
        var reporte = await resources.PaquetePP.ReporteVentaPP(value);
        kea.download(kea.base64ToBlob(reporte, 'application/vnd.ms-excel'), "Reporte venta de guías PP.xls");
    }

    render() {
        const puedeCambiarSucursal = this.puedeCambiarSucursal(this.props);
        return <ReporteVentasPPForm
            value={this.state.value}
            onChange={this.onChange}
            onGenerar={this.onGenerar}
            puedeCambiarSucursal={puedeCambiarSucursal}
        />;
    }
}

const ReporteVentasPPRx = componentToRx(ReporteVentasPPNoRX);

export class ReporteVentasPP extends React.PureComponent {

    session = () => resources.User.SessionRx;
    IdSucursalUsuario = createSelectorRx(this.session, (session) => (session.IdSucursal || undefined));

    render() {
        const IdSucursalUsuario = this.IdSucursalUsuario(this);
        return <ReporteVentasPPRx
            permisos={resources.User.PermisoRx}
            IdSucursalUsuario={IdSucursalUsuario}
        />;
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/reporteventapp/index.tsx